import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { CMS_FEATURES } from 'app/config/cms-features';
import { cmsFeaturePath, isCmsFeaturePathActive } from 'app/config/cms-nav';
import { translate } from 'i18n/jhipster-language';
const SIDEBAR_COLLAPSED_STORAGE_KEY = 'cms-mfe-sidebar-collapsed';
function readSidebarCollapsed() {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === '1';
    }
    catch {
        return false;
    }
}
const CmsShellNav = ({ variant = 'sidebar' }) => {
    const { pathname } = useLocation();
    const [collapsed, setCollapsed] = useState(readSidebarCollapsed);
    const isSidebar = variant === 'sidebar';
    const toggleSidebar = useCallback(() => {
        setCollapsed(prev => {
            const next = !prev;
            try {
                localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, next ? '1' : '0');
            }
            catch {
                /* ignore quota errors */
            }
            return next;
        });
    }, []);
    return (_jsxs("nav", { className: classNames('cms-mfe-shell-nav', {
            'cms-mfe-shell-nav--tabs': variant === 'tabs',
            'cms-mfe-shell-nav--sidebar': isSidebar,
            'cms-mfe-shell-nav--collapsed': isSidebar && collapsed,
        }), "aria-label": translate('form.cms'), "data-collapsed": isSidebar && collapsed ? 'true' : 'false', children: [_jsxs("div", { className: "cms-mfe-shell-nav__brand", children: [_jsx("span", { className: "cms-mfe-shell-nav__brand-icon pi pi-wallet", "aria-hidden": true }), _jsx("span", { className: "cms-mfe-shell-nav__brand-label", children: translate('form.cms') })] }), _jsx("ul", { className: "cms-mfe-shell-nav__list", role: "list", children: CMS_FEATURES.map(feature => {
                    const to = cmsFeaturePath(feature.pathSegment);
                    const active = isCmsFeaturePathActive(pathname, feature.pathSegment);
                    const label = translate(feature.labelKey);
                    return (_jsx("li", { className: "cms-mfe-shell-nav__item", children: _jsxs(NavLink, { to: to, title: collapsed && isSidebar ? label : undefined, className: ({ isActive }) => classNames('cms-mfe-shell-nav__link', {
                                'cms-mfe-shell-nav__link--active': isActive || active,
                            }), end: false, children: [feature.icon ? _jsx("i", { className: classNames(feature.icon, 'cms-mfe-shell-nav__link-icon'), "aria-hidden": true }) : null, _jsx("span", { className: "cms-mfe-shell-nav__link-label", children: label })] }) }, feature.id));
                }) }), isSidebar ? (_jsx("div", { className: "cms-mfe-shell-nav__footer", children: _jsxs("button", { type: "button", className: "cms-mfe-shell-nav__toggle", onClick: toggleSidebar, "aria-expanded": !collapsed, "aria-label": collapsed ? 'Expand sidebar' : 'Collapse sidebar', title: collapsed ? 'Expand sidebar' : 'Collapse sidebar', children: [_jsx("i", { className: classNames('pi cms-mfe-shell-nav__toggle-icon', collapsed ? 'pi-angle-double-right' : 'pi-angle-double-left'), "aria-hidden": true }), _jsx("span", { className: "cms-mfe-shell-nav__toggle-label", children: "Collapse" })] }) })) : null] }));
};
export default CmsShellNav;
